var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g, _path31, _path32, _path33, _path34, _path35, _g2, _path36, _g3, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g4, _path46, _path47, _path48, _g5, _path49, _path50, _path51, _path52, _mask, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _g6, _path63, _path64, _path65, _g7, _path66, _path67, _path68, _path69, _path70;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharacter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 379,
    viewBox: "0 0 530 379",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M486.838 316.065C478.723 322.817 416.213 365.721 327.005 358.808C322.205 318.202 303.901 151.375 324.718 125.228C324.718 125.228 375.226 101.14 421.751 111.254C468.276 121.367 486.383 131.057 489.699 139.445C492.212 145.788 488.624 263.907 486.838 316.065Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M420.207 129.074C393.409 152.283 358.89 147.378 359.647 129.558C359.768 126.772 362.75 123.32 362.75 123.32C362.75 123.32 362.357 122.73 361.706 121.716C360.706 120.202 359.086 117.734 357.209 114.857C353.893 109.725 349.745 103.275 346.853 98.5816C344.431 94.5847 404.824 57.4311 404.824 78.7936C404.824 108.892 419.601 114.554 419.601 114.554C425.127 116.795 430.305 120.338 420.207 129.074Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M437.141 175.04C437.141 175.04 431.74 193.565 434.308 198.877",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M430.836 121.227C430.836 139.11 377.495 156.624 361.865 138.689",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M394.434 84.0351C394.434 84.0351 394.261 97.3326 391.447 100.031C370.32 120.292 349.674 121.893 346.264 116.548C323.332 80.5847 328.75 71.101 326.413 64.9784C322.281 54.1609 317.211 36.5137 319.447 25.8203C324.44 1.93696 370 4.5 393.094 7.43277C404.447 18.9301 408.037 43.8687 405.639 64.6392",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M394.434 84.0351C394.434 84.0351 394.261 97.3326 391.447 100.031C370.32 120.292 349.674 121.893 346.264 116.548C323.332 80.5847 328.75 71.101 326.413 64.9784C322.281 54.1609 317.211 36.5137 319.447 25.8203C324.44 1.93696 370 4.5 393.094 7.43277C404.447 18.9301 408.037 43.8687 405.639 64.6392",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M332.671 57.1104C332.671 57.1104 326.367 54.2792 325 57.6584",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M348 53.1292C348 53.1292 361.128 47.6334 367.028 54.301",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M361.566 61.2642C362.089 63.1752 361.411 65.0272 360.05 65.3998C358.69 65.7724 357.163 64.525 356.639 62.6141C356.115 60.7031 356.793 58.8514 358.153 58.4787C359.514 58.1044 361.04 59.352 361.566 61.2642Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M334.71 65.2271C335.355 67.1006 334.798 68.9919 333.464 69.4508C332.131 69.9098 330.526 68.7628 329.881 66.8878C329.236 65.0143 329.793 63.123 331.127 62.664C332.461 62.2066 334.065 63.3535 334.71 65.2271Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M338.886 63C340.735 65.7347 341.319 71.1409 338.886 77.5428C336.453 83.9447 338.886 87 347.961 85.5",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M338.886 63C340.735 65.7347 341.319 71.1409 338.886 77.5428C336.453 83.9447 338.886 87 347.961 85.5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M387.371 57.8853C384.92 52.6257 393.822 38.4017 400.126 40.164C403.671 41.1541 408.302 47.6189 409.203 54.4107C410.104 61.2025 405.304 74.0322 400.187 76.8876C396.939 78.6998 394.263 73.7612 394.263 73.7612",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M387.371 57.8853C384.92 52.6257 393.822 38.4017 400.126 40.164C403.671 41.1541 408.302 47.6189 409.203 54.4107C410.104 61.2025 405.304 74.0322 400.187 76.8876C396.939 78.6998 394.263 73.7612 394.263 73.7612",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11768 314.854L172.177 274.864L528.996 316.065L437.141 378.897L1.11768 314.854Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11768 314.854L172.177 274.864L528.996 316.065",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11768 314.854L172.177 274.864L528.996 316.065",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M149.157 322.879L218.407 292.275L305.956 296.794L267.025 330.084L149.157 322.879Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M328.099 123.735C305.887 132.819 301.097 153.237 263.362 233.944C263.362 233.944 246.592 237.387 237.607 257.751C228.623 278.116 243.597 294.198 260.967 293.644C260.967 293.644 267.91 299.679 282.107 299.079C296.304 298.48 359.378 202.107 359.378 202.107L328.099 123.735Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M269.969 238.667C279.907 247.52 285.609 260.49 282.581 274.866",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M279.553 242.92C279.553 242.92 291.765 245.583 293.645 261.222",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M315.282 197.202C315.282 197.202 305.955 176.618 309.5 152.282",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M313.536 176.616C312.608 182.975 319.18 216.822 319.136 252.427",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M479.555 130.4C507.342 144.363 510.645 187.319 484.426 238.667C465.914 274.919 440.353 328.437 424.182 332.031C408.011 335.626 392.248 325.55 392.248 325.55C392.248 325.55 378.612 324.911 374.503 315.227C363.239 288.681 391.872 255.284 403.136 263.285C403.136 263.285 439.106 185.058 445.661 180.132",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M371.925 299.12C368.196 280.854 396.945 259.291 403.135 263.285C403.135 263.285 424.497 264.483 427.692 279.256",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M450.184 303.025C462.691 280.961 484.424 238.667 484.424 238.667",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M403.135 263.285C403.135 263.285 418.108 254.334 429.289 262.802",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M408.182 252.427C408.182 252.427 416.453 234.292 424.874 217.558C433.295 200.823 452.447 176.238 460.433 175.04",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M250.396 285.061C248.655 284.97 246.914 284.531 245.249 283.653C219.465 270.224 199.496 248.029 187.444 232.101C179.072 221.034 174.53 212.979 174.53 212.979L180.707 186.515C180.707 186.515 186.521 201.594 209.882 216.537C233.227 231.481 260.994 236.325 269.972 251.299C277.921 264.561 263.916 285.742 250.396 285.061Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_4816",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 186,
    width: 99,
    height: 100
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M250.396 285.061C248.655 284.97 246.914 284.531 245.249 283.653C219.465 270.224 199.496 248.029 187.444 232.101C179.072 221.034 174.53 212.979 174.53 212.979L180.707 186.515C180.707 186.515 186.521 201.594 209.882 216.537C233.227 231.481 260.994 236.325 269.972 251.299C277.921 264.561 263.916 285.742 250.396 285.061Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M250.396 285.061C250.124 283.29 249.639 281.427 248.852 279.474C243.447 265.939 210.745 239.035 210.745 239.035C202.963 238.793 194.408 235.553 187.444 232.101C179.072 221.034 174.53 212.979 174.53 212.979L180.707 186.515C180.707 186.515 186.521 201.594 209.882 216.537C233.227 231.481 260.994 236.325 269.972 251.299C277.921 264.561 263.916 285.742 250.396 285.061Z",
    fill: "#C1C1C1"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M250.396 285.061C248.655 284.97 246.914 284.531 245.249 283.653C219.465 270.224 199.496 248.029 187.444 232.101C179.072 221.034 174.53 212.979 174.53 212.979L180.707 186.515C180.707 186.515 186.521 201.594 209.882 216.537C233.227 231.481 260.994 236.325 269.972 251.299C277.921 264.561 263.916 285.742 250.396 285.061Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M192.106 211.428C192.106 211.428 188.911 225.55 180.493 222.384C175.93 220.669 167.197 207.099 165.544 200.263L192.106 211.428Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M155.002 124.553L161.874 120.998C161.874 120.998 181.302 121.171 193.353 130.965C204.299 139.862 209.844 153.811 209.844 153.811C209.844 153.811 252.381 130.326 295.809 143.802L313.535 242.536L232.095 247.909L181.267 199.576L155.002 124.553Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M319.132 246.484C319.132 246.484 309.578 246.197 296.8 246.621C277.482 247.226 250.79 249.406 238.587 256.507L238.012 256.31L226.838 252.419C226.838 252.419 226.763 252.313 226.611 252.086C224.552 249.028 207.944 225.213 184.25 215.508L150.699 121.761C150.699 121.761 185.536 123.32 204.552 154.736L214.106 158.188C214.106 158.188 270.956 141.352 302.781 147.408L319.132 246.484Z",
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_25_4816",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 121,
    width: 170,
    height: 136
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M319.132 246.484C319.132 246.484 309.578 246.197 296.8 246.621C277.482 247.226 250.79 249.406 238.587 256.507L238.012 256.31L226.838 252.419C226.838 252.419 226.763 252.313 226.611 252.086C224.552 249.028 207.944 225.213 184.25 215.508L150.699 121.761C150.699 121.761 185.536 123.32 204.552 154.736L214.106 158.188C214.106 158.188 270.956 141.352 302.781 147.408L319.132 246.484Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_25_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M226.611 252.086C224.552 249.028 207.944 225.213 184.25 215.508L150.699 121.761C150.699 121.761 185.536 123.32 204.552 154.736L226.611 252.086Z",
    fill: "black",
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_25_4816",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 121,
    width: 170,
    height: 136
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M319.132 246.484C319.132 246.484 309.578 246.197 296.8 246.621C277.482 247.226 250.79 249.406 238.587 256.507L238.012 256.31L226.838 252.419C226.838 252.419 226.763 252.313 226.611 252.086C224.552 249.028 207.944 225.213 184.25 215.508L150.699 121.761C150.699 121.761 185.536 123.32 204.552 154.736L214.106 158.188C214.106 158.188 270.956 141.352 302.781 147.408L319.132 246.484Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_25_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M296.8 246.621C277.482 247.226 250.79 249.406 238.587 256.507L238.012 256.31L215.695 161.594C215.695 161.594 233.951 157.493 239.571 159.566C239.571 159.566 276.681 186.958 296.8 246.621Z",
    fill: "black",
    fillOpacity: 0.7
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M319.132 246.484C319.132 246.484 309.578 246.197 296.8 246.621C277.482 247.226 250.79 249.406 238.587 256.507L238.012 256.31L226.838 252.419C226.838 252.419 226.763 252.313 226.611 252.086C224.552 249.028 207.944 225.213 184.25 215.508L150.699 121.761C150.699 121.761 185.536 123.32 204.552 154.736L214.106 158.188C214.106 158.188 270.956 141.352 302.781 147.408L319.132 246.484Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M214.101 158.191L236.013 249.076",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M226.841 252.427L205.556 161.597",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M172.76 213.12C167.894 211.767 158.101 182.557 162.59 169.988C162.59 169.988 167.92 160.736 170.088 160.103C173.487 159.111 187.172 159.4 186.51 161.703C184.979 167.028 174.48 166.939 174.48 166.939L171.072 173.173L171.219 176.616C171.219 176.616 176.16 173.013 177.985 173.11C178.913 173.16 183.765 175.537 187.609 177.573C190.899 179.316 192.908 180.256 192.172 181.841C189.738 187.078 179.352 183.403 179.352 183.403L175.455 189.281C175.455 189.281 179.223 189.933 180.878 190.124C182.687 190.333 196.228 199.425 195.814 200.566C194.198 205.017 181.202 200.203 181.202 200.203L178.899 202.118C178.899 202.118 188.478 204.595 189.45 204.952C190.975 205.514 196.805 210.004 196.714 210.515C196.013 214.448 187.971 211.555 187.971 211.555L180.937 211.269C180.937 211.269 179.517 212.642 177.173 213.211",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M172.76 213.12C167.894 211.767 158.101 182.557 162.59 169.988C162.59 169.988 167.92 160.736 170.088 160.103C173.487 159.111 187.172 159.4 186.51 161.703C184.979 167.028 174.48 166.939 174.48 166.939L171.072 173.173L171.219 176.616C171.219 176.616 176.16 173.013 177.985 173.11C178.913 173.16 183.765 175.537 187.609 177.573C190.899 179.316 192.908 180.256 192.172 181.841C189.738 187.078 179.352 183.403 179.352 183.403L175.455 189.281C175.455 189.281 179.223 189.933 180.878 190.124C182.687 190.333 196.228 199.425 195.814 200.566C194.198 205.017 181.202 200.203 181.202 200.203L178.899 202.118C178.899 202.118 188.478 204.595 189.45 204.952C190.975 205.514 196.805 210.004 196.714 210.515C196.013 214.448 187.971 211.555 187.971 211.555L180.937 211.269C180.937 211.269 179.517 212.642 177.173 213.211",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M171.219 176.616C171.219 176.616 166.727 180.435 165.5 181.534C164.274 182.633 164.621 186.153 164.621 186.153",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M167.927 193.897C167.898 197.753 170.504 200.079 171.69 201.32C172.875 202.562 169.793 205.942 173.193 208.366",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M392.182 315.795C382.568 318.414 372.122 301.518 359.374 283.078V283.062C350.956 270.89 341.539 258.036 330.714 249.709C329.851 249.058 328.973 248.422 328.095 247.817L334.423 216.068C347.565 222.957 355.71 233.994 369.351 245.334C391.304 263.608 410.759 274.826 416.149 282.911C421.539 290.996 408.655 311.299 392.182 315.795Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_25_4816",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 328,
    y: 216,
    width: 90,
    height: 101
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M392.182 315.795C382.568 318.414 372.122 301.518 359.374 283.078V283.062C350.956 270.89 341.539 258.036 330.714 249.709C329.851 249.058 328.973 248.422 328.095 247.817L334.423 216.068C347.565 222.957 355.71 233.994 369.351 245.334C391.304 263.608 410.759 274.826 416.149 282.911C421.539 290.996 408.655 311.299 392.182 315.795Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_25_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M359.374 283.062C350.956 270.89 341.539 258.036 330.714 249.709C332.652 249.679 334.136 249.482 334.908 249.073C334.908 249.073 352.016 263.002 359.374 283.062Z",
    fill: "#BBB7B7"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M392.182 315.795C382.568 318.414 372.122 301.518 359.374 283.078V283.062C350.956 270.89 341.539 258.036 330.714 249.709C329.851 249.058 328.973 248.422 328.095 247.817L334.423 216.068C347.565 222.957 355.71 233.994 369.351 245.334C391.304 263.608 410.759 274.826 416.149 282.911C421.539 290.996 408.655 311.299 392.182 315.795Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M337.981 246.621C337.451 247.726 336.376 248.513 334.908 249.073C334.575 249.209 334.226 249.315 333.863 249.421C333.787 249.437 333.681 249.452 333.575 249.482C323.416 252.132 300.555 246.621 300.555 246.621C300.555 246.621 285.582 239.505 284.673 237.824C284.113 236.749 283.432 234.933 282.993 233.736C282.75 233.025 282.584 232.54 282.584 232.54C282.584 232.54 277.194 229.543 276.588 227.151C275.998 224.758 274.787 224.153 278.087 223.699C281.388 223.26 299.344 223.699 299.344 223.699L279.889 215.765C279.889 215.765 267.005 209.27 265.809 206.984C264.613 204.683 263.114 203.184 269.7 204.092C276.286 204.986 290.669 209.179 290.669 209.179L301.933 211.571L290.669 206.772C290.669 206.772 268.504 204.092 272.697 197.204C272.697 197.204 281.085 197.204 285.279 197.204C289.473 197.204 302.887 198.778 306.535 199.899C310.199 201.019 334.423 216.068 334.423 216.068",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_25_4816",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 264,
    y: 197,
    width: 74,
    height: 54
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M337.981 246.621C337.451 247.726 336.376 248.513 334.908 249.073C334.575 249.209 334.226 249.315 333.863 249.421C333.787 249.437 333.681 249.452 333.575 249.482C323.416 252.132 300.555 246.621 300.555 246.621C300.555 246.621 285.582 239.505 284.673 237.824C284.113 236.749 283.432 234.933 282.993 233.736C282.75 233.025 282.584 232.54 282.584 232.54C282.584 232.54 277.194 229.543 276.588 227.151C275.998 224.758 274.787 224.153 278.087 223.699C281.388 223.26 299.344 223.699 299.344 223.699L279.889 215.765C279.889 215.765 267.005 209.27 265.809 206.984C264.613 204.683 263.114 203.184 269.7 204.092C276.286 204.986 290.669 209.179 290.669 209.179L301.933 211.571L290.669 206.772C290.669 206.772 268.504 204.092 272.697 197.204C272.697 197.204 281.085 197.204 285.279 197.204C289.473 197.204 302.887 198.778 306.535 199.899C310.199 201.019 334.423 216.068 334.423 216.068",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_25_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M333.575 249.482C323.416 252.132 300.555 246.621 300.555 246.621C300.555 246.621 285.582 239.505 284.673 237.824C284.113 236.749 283.432 234.933 282.993 233.736L301.373 235.795C301.373 235.795 299.162 239.384 301.373 243.335C303.417 246.999 326.702 250.724 333.575 249.482Z",
    fill: "#BBB7B7"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M337.981 246.621C337.451 247.726 336.376 248.513 334.908 249.073C334.575 249.209 334.226 249.315 333.863 249.421C333.787 249.437 333.681 249.452 333.575 249.482C323.416 252.132 300.555 246.621 300.555 246.621C300.555 246.621 285.582 239.505 284.673 237.824C284.113 236.749 283.432 234.933 282.993 233.736C282.75 233.025 282.584 232.54 282.584 232.54C282.584 232.54 277.194 229.543 276.588 227.151C275.998 224.758 274.787 224.153 278.087 223.699C281.388 223.26 299.344 223.699 299.344 223.699L279.889 215.765C279.889 215.765 267.005 209.27 265.809 206.984C264.613 204.683 263.114 203.184 269.7 204.092C276.286 204.986 290.669 209.179 290.669 209.179L301.933 211.571L290.669 206.772C290.669 206.772 268.504 204.092 272.697 197.204C272.697 197.204 281.085 197.204 285.279 197.204C289.473 197.204 302.887 198.778 306.535 199.899C310.199 201.019 334.423 216.068 334.423 216.068",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M282.581 232.539L304.708 235.791",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0925 300.272L117.528 316.979L218.984 293.832C218.984 293.832 157.016 276.193 156.434 276.617C155.852 277.041 62.0925 300.272 62.0925 300.272Z",
    fill: "#C1C1C1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0925 300.272L117.528 316.979L218.984 293.832C218.984 293.832 157.016 276.193 156.434 276.617C155.852 277.041 62.0925 300.272 62.0925 300.272Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-58-inside-1_25_4816",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8889 280.747C59.004 281.017 58.0275 295.044 62.0926 300.274L151.647 281.691L158.833 264.698L62.8889 280.747Z"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8889 280.747C59.004 281.017 58.0275 295.044 62.0926 300.274L151.647 281.691L158.833 264.698L62.8889 280.747Z",
    fill: "#C1C1C1",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-58-inside-1_25_4816)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M214.623 280.545C214.623 280.545 213.29 287.927 214.154 292.46L117.42 314.358L66.4301 299.371C66.4301 299.371 61.1281 289.995 65.7473 282.737L158.922 266.923L214.623 280.545Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8889 280.748L158.831 264.696L218.407 279.791L118.203 299.76L62.8889 280.748Z",
    fill: "#828282",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2909 289.71L117.028 304.811L200.065 288.101",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M213.876 289.644L124.581 308.698",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4976 295.654C68.2576 295.732 105.74 307.273 105.74 307.273",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M206.578 286.148L213.685 284.996",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M115.37 310.074L111.614 309.229",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7473 282.739C65.7473 282.739 72.6194 290.004 66.4301 299.373C66.4301 299.373 60.7027 291.738 65.7473 282.739Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_25_4816",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 282,
    width: 7,
    height: 18
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7473 282.739C65.7473 282.739 72.6194 290.004 66.4301 299.373C66.4301 299.373 60.7027 291.738 65.7473 282.739Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_25_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M65.7473 282.739C65.7473 282.739 72.6194 290.004 66.4301 299.373C66.4301 299.373 60.7027 291.738 65.7473 282.739Z",
    fill: "white",
    fillOpacity: 0.7
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7473 282.739C65.7473 282.739 72.6194 290.004 66.4301 299.373C66.4301 299.373 60.7027 291.738 65.7473 282.739Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M272.972 304.811L369.793 308.787L360.351 342.113L241.256 337.571L272.972 304.811Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_25_4816",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 241,
    y: 304,
    width: 129,
    height: 39
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M272.972 304.811L369.793 308.787L360.351 342.113L241.256 337.571L272.972 304.811Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_25_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M272.972 304.811L369.793 308.787L360.351 342.113L241.256 337.571L272.972 304.811Z",
    fill: "#E0E0E0"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M272.972 304.811L369.793 308.787L360.351 342.113L241.256 337.571L272.972 304.811Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M291.872 49.2689C291.808 48.4159 292.149 47.5739 292.7 46.9189C293.901 45.4889 295.689 44.9929 297.367 44.3709C301.543 42.8239 305.33 40.2819 308.405 37.0619C306.867 36.8599 305.364 36.4859 303.964 35.8169C301.073 34.4369 298.692 31.6019 298.664 28.3989C298.659 27.7979 298.773 27.1259 299.256 26.7679C300.023 26.2009 301.073 26.7799 301.908 27.2389C304.655 28.7469 306.809 29.0509 309.645 27.7179C311.406 26.8899 313.031 25.8569 314.152 24.4569C314.188 24.3769 314.216 24.2929 314.253 24.2139C314.691 23.2609 315.124 22.3459 315.555 21.4569C315.555 21.4539 315.557 21.4519 315.557 21.4489L315.556 21.4539C320.913 14 326.716 12.328 330.5 8.99999C335.5 2.49999 340.64 1.106 348 0.499995C355.361 -0.106005 360.364 0.500312 366.872 1.5C377.514 3.13483 372.5 8.5 381.5 2.5C387 1 389.17 4.80008 395 8C394.821 7.74 395.183 8.257 395 8C397.701 10.137 401.751 12.6409 405.136 13.2869C405.733 13.4009 406.425 13.5539 406.686 14.1029C406.945 14.6469 406.633 15.2829 406.287 15.7769C405.368 17.0899 404.141 18.1719 402.747 18.9619C403.653 20.0389 404.628 21.0519 405.715 21.9649C406.639 22.7409 407.739 23.6719 407.593 24.8689C407.48 25.7949 406.593 26.4719 405.677 26.6519C404.762 26.8309 403.82 26.6209 402.911 26.4129C403.965 27.5799 405.018 28.7479 406.072 29.9149C404.332 30.8909 404.503 31.3157 405.136 36.5867C405.769 41.8577 405.768 41.7439 405.677 45.4999C402.855 43.4999 402.747 41.4999 399.373 40.5867C396.339 40.5867 393.864 42.5867 391.364 46.5867C389.639 46.5347 386.918 57.4547 385.864 56.0867C378.877 47.0117 380.435 45.1619 377.872 33.9999C374.952 32.4849 370.147 37.8099 366.872 37.4999L359.872 38.9999C364.111 34.6499 365.872 37.4999 359.872 38.9999C345.372 40.9999 350.872 38.4999 342.011 39.6307C338.57 47.8697 331.61 48.8749 323.324 52.2019C324.624 58.3119 324.364 59.447 326 65L320.901 64.2269L320.913 64.2719C320.311 63.7649 319.774 63.2299 319.246 62.6899L319.074 62.5299L319.066 62.5049C318.224 61.6359 317.404 60.7569 316.44 59.9439C316.428 59.9659 316.416 59.9869 316.404 60.0089C314.368 63.6559 308.611 61.2049 309.822 57.2069C310.062 56.4139 310.417 55.6579 310.886 54.9709C309.983 56.7139 308.183 58.0309 306.221 58.1109C304.259 58.1909 302.254 56.8829 301.758 54.9829C301.419 53.6859 301.923 52.2429 302.885 51.3439C300.564 52.3679 297.94 52.7089 295.442 52.2549C293.803 51.9559 292.014 51.1479 291.872 49.2689Z",
    fill: "#263238"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M378.5 40C382.502 43.8389 383.981 75.5394 381 79C378.017 82.4614 373.423 85.7835 364 86.5C357.964 86.9604 351.544 85.2742 345.5 90.5C342.164 93.3845 335.664 93.9295 333.272 92.2128C338.426 102.998 341.941 119.478 354 119C362.564 118.66 385.661 109.593 392.5 100C399.339 90.4069 395.052 83.8276 393 74.2786C390.95 64.7287 387 55.0001 387 55.0001L378.5 40Z",
    fill: "#263238"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M346.831 105.738C346.404 103.559 346.708 101.138 347.421 99.2729C349.747 93.1736 356.75 89.9521 362.841 92.6648C365.45 93.8264 366 94 367.5 98.5C369 103 366.494 108.669 362.044 106.389C360.687 105.691 358.686 106.185 357.731 107.265C357.364 107.679 357.143 108.224 356.853 108.71C355.615 110.799 352.946 111.679 350.652 110.759C348.423 109.867 347.259 107.924 346.831 105.738Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M351.242 104.075C351.242 104.075 362.442 100.646 361.869 96",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacter);
export default __webpack_public_path__ + "static/media/Character.b3527b3a937b0ca6eff4ed8db3e49cd9.svg";
export { ForwardRef as ReactComponent };